module.exports = __webpack_public_path__ + "static/media/iGrant_logo.14d2fc8c.png";